import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const permissao = route.data?.['permissao'] as string | undefined;

  if (!permissao) {
    return true;
  }

  const hasAccess = authService.hasPermission(permissao);

  if (hasAccess) {
    return true;
  }

  return router.parseUrl('/login?error=unauthorized');
};